module.exports = __webpack_public_path__ + "img/xdn.d1bcab80.svg";